import { request } from 'utils/request';

export const getDisinfectionTechniques = async () =>
    await request(`/disinfection-technique`);
